import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import BasicOptionsPicker from './BasicOptionsPicker';

class RadioGroup extends BasicOptionsPicker {

	static propTypes = {
		options: PropTypes.array,
		selectedOptionID: PropTypes.any,
		onSelect: PropTypes.func,
		...BasicOptionsPicker.propTypes
	};

	constructor(props) {
		super(props);
		this.propsToOmitOnUpdate = ['onSelect'];
		this.generatedID = null;
	}

	getID() {
		const { id } = this.props;
		if(!_.isEmpty(id)) {
			return id;
		}
		if(!this.generatedID) {
			this.generatedID = _.uniqueId('radio_');
		}
		return this.generatedID;
	}

	onChange(event, opt) {
		const { onSelect } = this.props;
		event.currentTarget.checked && onSelect && onSelect(opt.id === null ? null : opt);
	}

	render() {
		const { options, selectedOptionID, className } = this.props;
		const id = this.getID();
		return (
			<span>
				{_.map(options, opt => {
					const optID = this.getOptionID(opt);
					const description = this.getOptionDescription(opt);
					return (
						<span key={id + optID} className={cx('radioer', className, {disabled: opt.disabled})}>
							<input type="radio" name={id} id={id +'-'+ optID} disabled={opt.disabled}
								   checked={optID == selectedOptionID} onChange={event => this.onChange(event, opt)}/>
							<label htmlFor={id +'-'+ optID}>
								{this.getOptionIcon(opt)}
								{this.getOptionTitle(opt)}
								{description && <small> ({description})</small>}
							</label>
						</span>
					);
				})}
			</span>
		);
	}

}

export default RadioGroup;
